<div class="modal-header">
    <h4 class="modal-title">Vista previa de distribución</h4>
    <a *ngIf="data?.url" [href]="data.url" target="_blank" rel="noopener" mat-flat-button color="primary" class="mt-2 mb-2 ms-4 me-3">
        Descargar <mat-icon>download</mat-icon>
    </a>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>

<div class="modal-body distribution-preview-body">
    <iframe
        *ngIf="officeViewerUrl"
        [src]="officeViewerUrl"
        title="Vista previa del archivo de distribución">
    </iframe>
</div>
